<template>
    <nav class="d-flex" style="margin-left:30px;">
        <router-link to="/" exact>Home</router-link>
        <div style="margin: 0 5px;color:white">|</div>
        <router-link to="/about">About</router-link>
        <div style="margin: 0 5px;color:white">|</div>
        <router-link to="/xxxxxxxx">Not Found</router-link>
    </nav>
</template>

<script>
export default {

}
</script>

<style>

</style>